import {
  useFlatFurnitures,
  useResidentialFurnitureProducers,
  useResidentialFurnitureTypes,
  useWarehouseFurnitures
} from '@services/protocols/hooks/protocolFurnitures'
import { useMemo } from 'react'
import { format } from 'date-fns'
import { pl } from 'date-fns/locale'
import { Box, Typography } from '@mui/material'

function FurnitureTypePreview({ id, protocolId }: { id: number; protocolId: number }) {
  const { flatFurnitures } = useFlatFurnitures(protocolId)
  const { warehouseFurnitures } = useWarehouseFurnitures(protocolId)

  const { getFurnitureProducerNameById } = useResidentialFurnitureProducers()
  const { getFurnitureTypeNameById } = useResidentialFurnitureTypes()

  const furniture = useMemo(() => {
    return [...flatFurnitures, ...warehouseFurnitures].find((furniture) => furniture.id === id)
  }, [flatFurnitures, warehouseFurnitures, id])

  if (furniture == null) {
    return <Typography variant='body2'>Nie znaleziono mebla.</Typography>
  }

  return (
    <Box>
      <Typography
        variant='h6'
        sx={{
          fontWeight: 'bold'
        }}
      >
        {getFurnitureTypeNameById(furniture.furnitureType)}
      </Typography>
      <Typography variant='body2'>
        Producent: {getFurnitureProducerNameById(furniture.producer)}
      </Typography>
      <Typography variant='body2'>Model: {furniture.model}</Typography>
      <Typography variant='body2'>Status: {furniture.status}</Typography>
      <Typography variant='body2'>
        Data zakupu:{' '}
        {!!furniture.purchaseDate
          ? format(new Date(furniture.purchaseDate as string), 'dd.MM.yyyy', {
              locale: pl
            })
          : 'Brak danych'}
      </Typography>
    </Box>
  )
}

export default FurnitureTypePreview
